import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react';
import {
  ErrorMessage,
  Input,
  InputWrapper,
  LabelContent,
} from './CommentForm.style';

interface CommentFormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
  value?: string;
  alwaysShowError?: boolean;
  errorMessage?: string;
}

export const CommentFormInput: React.FC<CommentFormInputProps> = ({
  errorMessage,
  label,
  value,
  alwaysShowError,
  ...otherProps
}) => {
  const [isTouched, setTouched] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null);
  const showError = (alwaysShowError || isTouched) && !isValid;

  useEffect(() => {
    const isValid = inputRef.current.checkValidity();
    setIsValid(isValid);
  }, [value]);

  return (
    <InputWrapper>
      <label>
        <LabelContent withAsterisk={label && otherProps.required}>
          {label}
        </LabelContent>
        <Input
          {...otherProps}
          ref={inputRef}
          onBlur={(e) => {
            setTouched(true);
            if (otherProps.onBlur) {
              otherProps.onBlur(e);
            }
          }}
          value={value}
          error={showError}
        />
      </label>
      {showError && (
        <ErrorMessage data-test="input-error-message">
          {errorMessage}
        </ErrorMessage>
      )}
    </InputWrapper>
  );
};
